<script>
  import { Porthole } from '@client/components/porthole';

  import { nameFromEmail } from '@client/utils/users';

  export let props = {};
  export let row = {};

  $: size = props.size(row);
  $: user = props.user(row);
  $: username = user ? user.split('@')[0] : user;
</script>

{#if size === 'sm'}
  {username}
{:else}
  <span class="d-inline d-lg-none">
    {username}
  </span>
  <span class="d-none d-lg-inline">
    <span class="d-inline-flex gap-2 align-items-center">
      {#key row.user}
        <Porthole
          details={{
            photoUrl: '',
            name: user,
            email: user
          }}
          size="small"
        />
      {/key}
      <div>
        <div class="bold">{nameFromEmail(user)}</div>
        <small class="text-muted">{user}</small>
      </div>
    </span>
  </span>
{/if}
